// Mock data for House Heads At Sea 2027: The Getaway
// NOTE: All data below is MOCKED for the frontend-only teaser build.

export const EVENT = {
  name: "House Heads At Sea",
  year: "2027",
  tagline: "The Getaway",
  edition: "The 4th Annual House Music Cruise Experience",
  ship: "Norwegian Prima",
  cruiseLine: "Norwegian Cruise Line",
  date: "December 4, 2027",
  dateShort: "DEC 4TH, 2027",
  duration: "7-Night Caribbean Cruise",
  departurePort: "San Juan, Puerto Rico",
  phone: "470-632-8963",
  phoneHref: "tel:+14706328963",
  bookingUrl: "https://traveljoy.com/bookings/gkC8Si1TLk3MzhcpkoVYjWk9",
  website: "HouseHeadsAtSea.com",
  poweredBy: "Powered by DJ DaVyne & Kompass Events",
  depositFrom: "$300",
  holdFor: "$100",
  finalPayoff: "July 23, 2027",
  badge: "4th Annual Cruise",
  portsIntro: "Six stunning Caribbean islands — Tortola, St. Kitts, Barbados, St. Lucia, St. Thomas and St. Maarten. Explore turquoise waters, white-sand beaches and island culture between the parties.",
  id: "caribbean-2027",
};

export const COLORS = {
  red: "#E50914",
  black: "#0A0A0A",
  charcoal: "#1A1A1A",
  silver: "#B3B3B3",
  white: "#FFFFFF",
  green: "#1B8A5A",
  yellow: "#F2C04C",
};

export const HERO_IMAGE = "/prima.jpg";

export const SHIP_IMAGE = "/prima.jpg";

export const DJS = [
  {
    name: "DJ Silk Smooth",
    role: "Co-Hosting DJ",
    img: "/djs/final_silk_smooth.png?v=2",
  },
  {
    name: "Tantra",
    role: "Co-Hosting DJ",
    img: "/djs/final_tantra.png?v=1",
  },
  {
    name: "DJ DaVyne",
    role: "Host / DJ",
    img: "/djs/final_davyne.png?v=4",
  },
  {
    name: "DJ T-Wise",
    role: "Featured DJ",
    img: "/djs/final_twise.png?v=4",
  },
  {
    name: "DJ Randall Smooth",
    role: "Featured DJ",
    img: "/djs/final_randall_smooth.png?v=4",
  },
];

export const PORTS = [
  {
    name: "San Juan",
    country: "Puerto Rico",
    note: "Embarkation Port",
    time: "Board 11am \u2022 Depart 4pm",
    excursion: "Wander historic Old San Juan, El Morro fortress & colorful streets before we set sail.",
    img: "/ports/sanjuan.jpg",
  },
  {
    name: "Tortola",
    country: "British Virgin Islands",
    note: "Sailors' Paradise",
    time: "Docked 7am - 5pm",
    excursion: "Beach-hop the BVIs, snorkel crystal bays and soak in true sailors' paradise.",
    img: "/ports/tortola.jpg",
  },
  {
    name: "Basseterre",
    country: "St. Kitts",
    note: "Lush & Historic",
    time: "Docked 7am - 4pm",
    excursion: "Ride the scenic railway, explore rainforest trails and colonial history.",
    img: "/ports/basseterre.webp",
  },
  {
    name: "Bridgetown",
    country: "Barbados",
    note: "Island Culture",
    time: "Docked 10am - 6pm",
    excursion: "Beach party day \u2014 swim with turtles and feel the vibrant Bajan culture.",
    img: "/ports/bridgetown.webp",
  },
  {
    name: "Castries",
    country: "St. Lucia",
    note: "The Pitons",
    time: "Docked 7am - 3pm",
    excursion: "Marvel at the iconic Pitons, chase waterfalls and cruise the lush coastline.",
    img: "/ports/castries.webp",
  },
  {
    name: "St. Thomas",
    country: "U.S. Virgin Islands",
    note: "Magens Bay",
    time: "Docked 10am - 6pm",
    excursion: "World-famous Magens Bay, duty-free shopping in Charlotte Amalie and easy island vibes.",
    img: "/ports/stthomas.webp",
  },
  {
    name: "Philipsburg",
    country: "St. Maarten",
    note: "Dual-Nation Isle",
    time: "Docked 7am - 5pm",
    excursion: "Stroll Front Street, watch the planes at Maho Beach and enjoy dual-nation charm.",
    img: "/ports/philipsburg.jpg",
  },
];

export const ITINERARY = [
  {
    day: "PRE-CRUISE",
    date: "FRI, DEC 3",
    port: "San Juan Launch Party",
    time: "Caribe Hilton \u2022 8pm - 2am",
    events: ["Meet & Greet (7pm)", "Swag Bag Pickup", "Official Launch Party (9pm)"],
  },
  {
    day: "DAY 1",
    date: "SAT, DEC 4",
    port: "San Juan, Puerto Rico",
    time: "Board 11am \u2022 Departs 4pm",
    events: ["Embark & Swag Distribution", "Group Pictures (7pm)", "EXKAPE Denim & White Party (9pm)"],
  },
  {
    day: "DAY 2",
    date: "SUN, DEC 5",
    port: "Tortola, BVI",
    time: "Docked 7am - 5pm",
    events: ["Group Breakfast", "Group Excursion", "Unity Games", "Steppin' to My House \u2013 All White Party"],
  },
  {
    day: "DAY 3",
    date: "MON, DEC 6",
    port: "Basseterre, St. Kitts",
    time: "Docked 7am - 4pm",
    events: ["Group Breakfast", "House Heads Gone Wild", "Swimsuit Splash Pool Party", "Roaring 20s Party"],
  },
  {
    day: "DAY 4",
    date: "TUE, DEC 7",
    port: "Bridgetown, Barbados",
    time: "Docked 10am - 6pm",
    events: ["Group Breakfast", "Beach Party", "Movie Night", "Boots & Brims Dance Party"],
  },
  {
    day: "DAY 5",
    date: "WED, DEC 8",
    port: "Castries, St. Lucia",
    time: "Docked 7am - 3pm",
    events: ["Group Breakfast", "Beach Party", "Unity Games", "Rep Your City Dance Party"],
  },
  {
    day: "DAY 6",
    date: "THU, DEC 9",
    port: "St. Thomas, U.S. Virgin Islands",
    time: "Docked 10am - 6pm",
    events: ["HHAS Breakfast Award Ceremony", "House Heads Gone Wild", "Masquerade Ball \u2013 Royal Blue & Gold"],
  },
  {
    day: "DAY 7",
    date: "FRI, DEC 10",
    port: "Philipsburg, St. Maarten",
    time: "Docked 7am - 5pm",
    events: ["HHAS Breakfast & Birthday Shout Outs", "Gift Exchange & Awards", "Red, White & Black Signature Holiday Party"],
  },
  {
    day: "DAY 8",
    date: "SAT, DEC 11",
    port: "San Juan, Puerto Rico",
    time: "Disembark 7:00am",
    events: ["Thank You & Shout-outs", "Swag Bag Distribution", "Get Home Safely"],
  },
];

// Base booking link + per-package direct links (from TravelJoy)
export const BOOKING_BASE =
  "https://traveljoy.com/bookings/gkC8Si1TLk3MzhcpkoVYjWk9/client/edit?package_token=";

export const CABINS = [
  {
    name: "Inside Stateroom",
    price: "$2,153.65",
    featured: false,
    drinks: false,
    size: "Cozy & modern",
    guests: "2 Guests",
    token: "5GHxhMPBULZ2v9C1JRYPtxoz",
    desc: "Comfortable interior stateroom with private bath and two lower beds convertible to a queen.",
    perks: ["Complimentary dining", "Private bathroom", "Ample storage"],
  },
  {
    name: "Inside Stateroom",
    price: "$2,436.95",
    featured: false,
    drinks: true,
    size: "Cozy & modern",
    guests: "2 Guests",
    token: "3UGUKTytt2cAFsLrAD99gPyS",
    desc: "Interior stateroom upgraded with the Free at Sea drink & specialty dining package.",
    perks: ["Unlimited Open Bar", "3 Specialty Dining Meals", "150 Wi-Fi Minutes"],
  },
  {
    name: "Ocean View Stateroom",
    price: "$2,438.80",
    featured: false,
    drinks: false,
    size: "186\u2013370 sq. ft.",
    guests: "2 Guests",
    token: "gQiTHARkNFNPaUi2ifXEaFEo",
    desc: "Wake up to the sea through a large picture window with a comfortable sitting area.",
    perks: ["Large picture window", "Complimentary dining", "Sitting area"],
  },
  {
    name: "Ocean View Stateroom",
    price: "$2,698.80",
    featured: false,
    drinks: true,
    size: "186\u2013370 sq. ft.",
    guests: "2 Guests",
    token: "jDSSFHz7536M3pb33oF13YTZ",
    desc: "Ocean View room with the full Free at Sea drink & specialty dining package.",
    perks: ["Unlimited Open Bar", "3 Specialty Dining Meals", "$50 Excursion Credit"],
  },
  {
    name: "Balcony Stateroom",
    price: "$2,468.15",
    featured: true,
    drinks: false,
    size: "231\u2013358 sq. ft.",
    guests: "2 Guests",
    token: "NWPXDXgS8N46P7xpWj2dDBaL",
    desc: "Private balcony with floor-to-ceiling glass doors and your own outdoor retreat.",
    perks: ["Private balcony", "Floor-to-ceiling glass", "Sitting area"],
  },
  {
    name: "Balcony Stateroom",
    price: "$2,642.95",
    featured: true,
    drinks: true,
    size: "231\u2013358 sq. ft.",
    guests: "2 Guests",
    token: "nM5ax8SUPCJZPqe6B55EZv8V",
    desc: "Private balcony room loaded with the Free at Sea drink & specialty dining package.",
    perks: ["Unlimited Open Bar", "3 Specialty Dining Meals", "$50 Excursion Credit"],
  },
  {
    name: "Club Balcony Suite",
    price: "$3,398.80",
    featured: false,
    drinks: false,
    size: "Spacious mini-suite",
    guests: "2 Guests",
    token: "y9jFo6mABYL865tugmpLZ56S",
    desc: "Upgraded space & comfort (formerly Mini-Suite) with private balcony and spacious bath.",
    perks: ["Private balcony", "Spacious bathroom", "Extra living space"],
  },
  {
    name: "Club Balcony Suite",
    price: "$3,658.80",
    featured: false,
    drinks: true,
    size: "Spacious mini-suite",
    guests: "2 Guests",
    token: "po8fCYL8a9p2TYfHdoRziFNq",
    desc: "Top-tier Club Balcony Suite with the full Free at Sea drink & specialty dining package.",
    perks: ["Unlimited Open Bar", "3 Specialty Dining Meals", "$50 Excursion Credit"],
  },
];

export const EXPERIENCES = [
  "Non-Stop House Music",
  "Pool Parties",
  "Theme Nights",
  "Live DJ Sets",
  "Dancing",
  "Games",
  "Special Events",
  "And More!",
];

export const EXPERIENCE_IMAGES = [
  "/experience/dancing.png",
  "/experience/games.png",
  "/experience/movie-night.png",
  "/experience/and-more.webp",
];

export const LAUNCH_PARTY = {
  date: "Friday, December 3, 2027",
  venue: "Caribe Hilton",
  location: "San Juan, Puerto Rico",
  tagline: "It All Kicks Off The Night Before We Sail",
  intro:
    "Arrive a day early and start the celebration on land. Meet the House Heads At Sea family, grab your official swag and set the tone for seven unforgettable nights at sea.",
  events: [
    {
      time: "7:00 PM",
      title: "Meet & Greet + Swag Bag Pickup",
      desc: "Connect with fellow guests and the HHAS team while you collect your official swag bag, wristbands, lanyard and event materials.",
    },
    {
      time: "9:00 PM",
      title: "Official Launch Party",
      desc: "The pre-cruise Launch Party takes over the Caribe Hilton Ballroom \u2014 live DJ sets, dancing and pure house-music energy until 2:00 AM.",
    },
  ],
  note: "Pre-cruise event held at the Caribe Hilton the night before embarkation. Hotel stay booked separately.",
  image:
    "https://images.unsplash.com/photo-1578736641330-3155e606cd40?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA1ODh8MHwxfHNlYXJjaHwyfHxuaWdodGNsdWIlMjBjcm93ZCUyMGRhbmNpbmd8ZW58MHx8fHwxNzg3Nzk5MDg0fDA&ixlib=rb-4.1.0&q=85",
};

export const FAQS = [
  {
    q: "Do I need a passport?",
    a: "A valid passport is strongly recommended for this Caribbean sailing and required for some ports. Please ensure your passport is valid for at least 6 months beyond the December 2027 return date.",
  },
  {
    q: "When are my eDocs available?",
    a: "Norwegian opens online check-in 21 days before sailing — November 13, 2027 for our December 4 departure. Your electronic cruise documents (eDocs) include your Boarding Pass (required for boarding), Luggage Tags and important Cruise Information. Per Norwegian, eDocs are typically ready to download about 24 hours after you complete online check-in.",
  },
  {
    q: "How do luggage tags work?",
    a: "Your luggage tags are included in your eDocs. Print them and securely attach one to each checked bag before you arrive at the San Juan cruise terminal. Porters will collect your tagged luggage at the pier and deliver it to your stateroom.",
  },
  {
    q: "How do I complete online check-in?",
    a: "Download the Norwegian Cruise Line (NCL) app (or use your NCL account at ncl.com) and complete online check-in as soon as your window opens on November 13, 2027. Check-in closes 3 days before sailing (December 1, 2027). Through the app you can complete your required guest information, upload your security photo and provide travel details, select your available port arrival time, and access your cruise information and eDocs when released. Don't wait until the last minute!",
  },
  {
    q: "What should I bring to the terminal?",
    a: "Bring your boarding pass (printed eDocs or on the NCL app), your passport or other required travel documents, and your luggage with tags already attached. You may only enter the terminal during the port arrival time you selected, and Norwegian asks all guests to be on board at least 2 hours before departure (boarding opens 11 AM, we sail at 4:00 PM on December 4, 2027). Guests who don't complete check-in or arrive on time may be denied boarding.",
  },
  {
    q: "What is the cancellation policy?",
    a: "All deposits and payments are non-refundable unless stated in writing. Travel insurance is strongly encouraged. Name changes within 120 days of sailing may incur a $150 administrative fee plus any supplier fees.",
  },
];

export const BIRTHDAY_MONTHS = ["November", "December", "January"];

export const CABIN_OPTIONS = [
  "Inside Stateroom",
  "Ocean View Stateroom",
  "Balcony Stateroom",
  "Club Balcony Suite",
  "Not sure yet",
];

export const NAV_LINKS = [
  { label: "Home", href: "#home" },
  { label: "The DJs", href: "#djs" },
  { label: "Ports", href: "#ports" },
  { label: "Itinerary", href: "#itinerary" },
  { label: "Cabins", href: "#pricing" },
  { label: "Community", href: "#community" },
  { label: "FAQ", href: "#faq" },
  { label: "Blog", href: "/blog" },
];

// Payment estimator config: EZ Monthly Payment Plan (balance after deposit split
// into equal monthly payments, paid in full by the final payoff date).
export const PAYMENT = {
  depositPerPerson: 300,
  payoffDate: "2027-07-23",
};

// Early-bird promo: hold a cabin for the low price until this deadline, then it expires.
export const EARLY_BIRD = {
  deadline: "2026-11-30T23:59:59-05:00",
  holdPrice: "$100",
  deadlineLabel: "Nov 30, 2026",
};

export const TESTIMONIALS = [
  {
    quote:
      "Best vacation I've ever taken. Non-stop house music, incredible people and the parties never stopped. Already booked for 2027!",
    name: "Tanya R.",
    trip: "HHAS 2025",
    initials: "TR",
  },
  {
    quote:
      "The vibe on this cruise is unmatched. You come as a stranger and leave with a whole new family. The DJs were absolutely on fire.",
    name: "Marcus D.",
    trip: "HHAS 2024",
    initials: "MD",
  },
  {
    quote:
      "Theme nights, pool parties, beautiful islands — every single day was a movie. The organization was flawless from start to finish.",
    name: "Kim & Andre",
    trip: "HHAS 2025",
    initials: "KA",
  },
  {
    quote:
      "I sailed solo and never felt alone for a second. So much love on that boat. The music, the dancing, the memories — worth every penny.",
    name: "Denise W.",
    trip: "HHAS 2024",
    initials: "DW",
  },
];

// Highlights gallery — real photos from past House Heads At Sea sailings
export const GALLERY = [
  {
    src: "/gallery/djset.webp?v=2",
    caption: "Live DJ Sets",
    span: "lg:col-span-2 lg:row-span-2",
  },
  {
    src: "/gallery/theme.webp",
    caption: "Theme Nights",
    span: "",
  },
  {
    src: "/gallery/rwb.webp",
    caption: "Red, White & Black Party",
    span: "",
  },
  {
    src: "/gallery/poolparty.webp",
    caption: "Pool Party Vibes",
    span: "lg:col-span-2",
  },
  {
    src: "/gallery/excursions.webp",
    caption: "Island Excursions",
    span: "",
  },
  {
    src: "/gallery/allwhite.webp",
    caption: "All White Party",
    span: "lg:col-span-2",
  },
];

export const HOTEL = {
  name: "Caribe Hilton",
  location: "San Juan, Puerto Rico",
  tagline: "Where The Getaway Begins",
  intro:
    "Fly in early and stay where the pre-cruise magic happens. The Caribe Hilton hosts our Meet & Greet, Swag Bag pickup and Official Launch Party on December 3 \u2014 so you wake up rested and ready to board the Norwegian Prima the next morning.",
  bullets: [
    "Host hotel for the Dec 3 Meet & Greet & Launch Party",
    "Minutes from the San Juan cruise port",
    "Legendary beachfront resort in Puerto Rico",
    "Arrive Dec 3 (or earlier) to enjoy the island stress-free",
  ],
  note: "Hotel accommodations, airfare and airport/port transfers are not included in the cruise price. We recommend booking your Caribe Hilton stay early as rooms fill fast around sailing week.",
  image: "/hotel-caribe.webp",
};
